import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class LeitungsverlustFernwaerme extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    kanton_id: number | null = null;
    gemeinde_id: number | null = null;
    verlust: number | null = null;

    // view fields
    kanton_kuerzel: string | null = null;
    kanton: string | null = null;
    gemeinde: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'LeitungsverlustFernwaerme';
    }
}

export async function createNewLeitungsverlustFernwaerme(): Promise<LeitungsverlustFernwaerme> {
    const model = createModel(LeitungsverlustFernwaerme, {});

    await model.save();
    return model;
}

export class LeitungsverlustFernwaermeCollection extends BaseCollection<LeitungsverlustFernwaerme> {
    protected modelCls = LeitungsverlustFernwaerme;

    public getModelClassName(): string {
        return 'LeitungsverlustFernwaerme';
    }
}
